import { createAction, props } from '@ngrx/store';

export const getData = createAction(
  '[Units/Shared] Get Data',
);
export const clearData = createAction(
  '[Units/Shared] Clear Data',
);

export type UnitsSharedActionsUnion = ReturnType<
  typeof getData |
  typeof clearData
  >;
